/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Lugar', Lugar);

    /* @ngInject */
    function Lugar($resource) {
        return $resource('api/admin/lugar/:id', {}, {
            'updateCoordenadas': {
                method: 'POST',
                isArray: false,
                url: 'api/admin/lugar/updateCoordenadas'
            },
            'setRevisado': {
                method: 'POST',
                isArray: false,
                url: 'api/admin/lugar/setRevisado'
            },
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/lugar/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/lugar/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/lugar/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/lugar/findUsedLetters'
            },
            'simpleFilter': {
                method: 'GET',
                isArray: false,
                url: 'api/public/lugar/simpleFilter'
            },
            'canonicoFilter': {
                method: 'GET',
                isArray: false,
                url: 'api/public/lugar/canonicoFilter'
            },
            'filterGis': {
                method: 'GET',
                isArray: true,
                url: 'api/public/lugar/filterGis'
            }
        });
    }
})();
